import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import {
  aboutSection,
  countryCards,
  heroSlides,
  highlights,
  processSteps,
  serviceCards,
  testimonials,
} from '../content/siteContent';

function Home() {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveSlide((current) => (current + 1) % heroSlides.length);
    }, 4500);

    return () => window.clearInterval(timer);
  }, []);

  const slide = heroSlides[activeSlide];

  return (
    <main>
      <Seo
        title="College Admission Guidance Ahmedabad | Vedanskrix"
        description="Vedanskrix College Admission provides profile evaluation, college shortlisting, application support, visa guidance, and counselling for students."
        keywords={[
          'college admission guidance Ahmedabad',
          'study abroad counselling Gujarat',
          'student visa support Ahmedabad',
          'college admission consultant',
          'Vedanskrix college admission',
        ]}
        image={slide.image}
      />

      <section className="ca-hero">
        <div className="ca-hero__media" style={{ backgroundImage: `url(${slide.image})` }}>
          <div className="ca-hero__overlay" />
        </div>

        <div className="ca-container ca-hero__content">
          <div className="ca-hero__copy">
            <span className="ca-eyebrow">{slide.eyebrow}</span>
            <h1>{slide.title}</h1>
            <p>{slide.description}</p>
            <div className="ca-hero__actions">
              <Link to={slide.primaryCta.to} className="ca-button">
                {slide.primaryCta.label}
              </Link>
              <Link to={slide.secondaryCta.to} className="ca-button ca-button--ghost">
                {slide.secondaryCta.label}
              </Link>
            </div>
          </div>

          <div className="ca-hero__controls">
            <button type="button" onClick={() => setActiveSlide((activeSlide - 1 + heroSlides.length) % heroSlides.length)}>
              Prev
            </button>
            <div className="ca-hero__dots">
              {heroSlides.map((item, index) => (
                <button
                  key={item.title}
                  type="button"
                  aria-label={`Go to slide ${index + 1}`}
                  className={index === activeSlide ? 'ca-hero__dot ca-hero__dot--active' : 'ca-hero__dot'}
                  onClick={() => setActiveSlide(index)}
                />
              ))}
            </div>
            <button type="button" onClick={() => setActiveSlide((activeSlide + 1) % heroSlides.length)}>
              Next
            </button>
          </div>
        </div>
      </section>

      <section className="ca-section ca-section--stats">
        <div className="ca-container ca-stats">
          {highlights.map((item) => (
            <article key={item.label} className="ca-stat-card">
              <strong>{item.value}</strong>
              <span>{item.label}</span>
            </article>
          ))}
        </div>
      </section>

      <section className="ca-section">
        <div className="ca-container ca-about">
          <div className="ca-about__image">
            <img src="/aboutus.png" alt="Students planning college admission with Vedanskrix" />
          </div>
          <div className="ca-about__content">
            <span className="ca-eyebrow">About Us</span>
            <h2>{aboutSection.title}</h2>
            {aboutSection.body.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            <Link to="/contact" className="ca-text-link">
              Speak with an admission counsellor
            </Link>
          </div>
        </div>
      </section>

      <section className="ca-section ca-section--soft">
        <div className="ca-container">
          <div className="ca-section__heading">
            <span className="ca-eyebrow">Services</span>
            <h2>Everything students need from first consultation to final filing.</h2>
          </div>
          <div className="ca-card-grid">
            {serviceCards.map((service) => (
              <article key={service.title} className="ca-info-card">
                <h3>{service.title}</h3>
                <p>{service.summary}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="ca-section">
        <div className="ca-container">
          <div className="ca-section__heading">
            <span className="ca-eyebrow">Destinations</span>
            <h2>Popular countries we guide students for.</h2>
          </div>
          <div className="ca-country-grid">
            {countryCards.map((country) => (
              <article key={country.name} className="ca-country-card">
                <span>{country.code}</span>
                <h3>{country.name}</h3>
                <p>{country.focus}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="ca-section ca-section--soft">
        <div className="ca-container">
          <div className="ca-section__heading">
            <span className="ca-eyebrow">Process</span>
            <h2>A clear step-by-step structure for students and families.</h2>
          </div>
          <div className="ca-process-strip">
            {processSteps.map((step) => (
              <article key={step.step} className="ca-process-card">
                <span>{step.step}</span>
                <h3>{step.title}</h3>
                <p>{step.detail}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="ca-section">
        <div className="ca-container">
          <div className="ca-section__heading">
            <span className="ca-eyebrow">Happy Students</span>
            <h2>Confidence grows when the process feels guided and transparent.</h2>
          </div>
          <div className="ca-testimonial-grid">
            {testimonials.map((item) => (
              <article key={item.name} className="ca-testimonial-card">
                <p>{item.quote}</p>
                <strong>{item.name}</strong>
                <span>{item.destination}</span>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="ca-section ca-section--cta">
        <div className="ca-container ca-cta">
          <div>
            <span className="ca-eyebrow">Ready To Start?</span>
            <h2>Plan your next intake with a more organised admission strategy.</h2>
          </div>
          <Link to="/contact" className="ca-button">
            Contact Admission Team
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Home;
